// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@-webkit-keyframes spin-data-v-bb979d44{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin-data-v-bb979d44{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.button-spinner__wrapper[data-v-bb979d44]{-webkit-animation:spin-data-v-bb979d44 1.5s linear infinite;animation:spin-data-v-bb979d44 1.5s linear infinite}", ""]);
// Exports
module.exports = exports;
